import { Button, ButtonRow, FormLabel } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import type { IQuestionnaireFormProps } from '../../../Questionnaire';
import {
    completeFosq10QuestionOptions,
    partialFosq10QuestionOptions,
} from '../../../../../../../common/validation/customControls/somnology';
import { Step } from '../../../../../elements/atoms/step/Step';
import { CustomContainer } from '../../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../../elements/molecules/stack/Stack';
import { PageIntro } from '../../../../../elements/organisms/pageIntro/PageIntro';
import { QuestionnaireRadioGroup } from '../../../../../elements/organisms/questionnaireRadioGroup/QuestionnaireRadioGroup';
import { StyledFormGroup } from '../../../../../elements/organisms/StyledFormGroup/StyledFormGroup';

export function Step2(props: IQuestionnaireFormProps) {
    const [isSaving, setIsSaving] = useState<boolean>(false);

    useEffect(() => {
        if (props.errors.size === 0) {
            setIsSaving(false);
        }
    }, [props.errors.size]);

    return (
        <>
            <PageIntro title="FOSQ-10: vragen deel 2/2" />

            <CustomContainer>
                <Stack>
                    <Step>5/10</Step>
                    <StyledFormGroup
                        label=""
                        layout="vertical"
                    >
                        <FormLabel error={props.errors.has('difficultyVisitingFriendsAndFamily')}>
                            Heb je moeite met bezoeken van vrienden en familie <b>bij je thuis</b> omdat je slaperig of
                            moe wordt?
                        </FormLabel>
                        <QuestionnaireRadioGroup
                            {...props}
                            customControlData={props.procedure.customControlData}
                            customControlKey="difficultyVisitingFriendsAndFamily"
                            questionnaireOptions={completeFosq10QuestionOptions}
                        />
                    </StyledFormGroup>
                </Stack>

                <Stack>
                    <Step>6/10</Step>
                    <StyledFormGroup
                        hasErrors={props.errors.has('haveRelationshipsDeteriorated')}
                        label="Is je relatie met familie, vrienden of collega’s op het werk verslechterd omdat je slaperig of moe bent?"
                        layout="vertical"
                    >
                        <QuestionnaireRadioGroup
                            {...props}
                            customControlData={props.procedure.customControlData}
                            customControlKey="haveRelationshipsDeteriorated"
                            questionnaireOptions={partialFosq10QuestionOptions}
                        />
                    </StyledFormGroup>
                </Stack>

                <Stack>
                    <Step>7/10</Step>
                    <StyledFormGroup
                        hasErrors={props.errors.has('difficultyWatchingVideoOrFilm')}
                        label="Valt het je moeilijk naar video of film te kijken omdat je slaperig of moe wordt?"
                        layout="vertical"
                    >
                        <QuestionnaireRadioGroup
                            {...props}
                            customControlData={props.procedure.customControlData}
                            customControlKey="difficultyWatchingVideoOrFilm"
                            questionnaireOptions={completeFosq10QuestionOptions}
                        />
                    </StyledFormGroup>
                </Stack>

                <Stack>
                    <Step>8/10</Step>
                    <StyledFormGroup
                        label=""
                        layout="vertical"
                    >
                        <FormLabel error={props.errors.has('difficultyBeingActiveAtNight')}>
                            Valt het je moeilijk <b>&apos;s avonds</b> zo actief te zijn als je zou willen omdat je
                            slaperig of moe bent?
                        </FormLabel>
                        <QuestionnaireRadioGroup
                            {...props}
                            customControlData={props.procedure.customControlData}
                            customControlKey="difficultyBeingActiveAtNight"
                            questionnaireOptions={partialFosq10QuestionOptions}
                        />
                    </StyledFormGroup>
                </Stack>

                <Stack>
                    <Step>9/10</Step>
                    <StyledFormGroup
                        label=""
                        layout="vertical"
                    >
                        <FormLabel error={props.errors.has('difficultyBeingActiveInTheMorning')}>
                            Valt het je moeilijk <b>&apos;s morgens</b> zo actief te zijn als je zou willen omdat je
                            slaperig of moe bent?
                        </FormLabel>
                        <QuestionnaireRadioGroup
                            {...props}
                            customControlData={props.procedure.customControlData}
                            customControlKey="difficultyBeingActiveInTheMorning"
                            questionnaireOptions={partialFosq10QuestionOptions}
                        />
                    </StyledFormGroup>
                </Stack>

                <Stack>
                    <Step>10/10</Step>
                    <StyledFormGroup
                        hasErrors={props.errors.has('needForIntimacy')}
                        label="Heeft u behoefte aan intimiteit of seks te lijden onder het feit dat u slaperig of moe bent?"
                        layout="vertical"
                    >
                        <QuestionnaireRadioGroup
                            {...props}
                            customControlData={props.procedure.customControlData}
                            customControlKey="needForIntimacy"
                            questionnaireOptions={completeFosq10QuestionOptions}
                        />
                    </StyledFormGroup>
                </Stack>

                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        isDisabled={isSaving}
                        onClick={async () => {
                            setIsSaving(true);
                            if (props.submit) {
                                await props.submit();
                            }
                        }}
                        variant="solid"
                        width="full-below-small"
                    >
                        Verzenden
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
